import {Component, OnInit} from '@angular/core';
import {BaseComponent} from "../../base.component";
import {UserService} from "../../common/user.service";
import {LoggerService} from "../../common/logger.service";
import {Util} from "../../util/util";
import {CartService} from "../cart.service";
import {AlertUtilService} from "../../alert/alert-util.service";
import {ISavedProduct} from "./cart-saved-product-models";
import {CartSavedProductService} from "./cart-saved-product.service";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {ProductUtil} from '../../util/product-util';

@Component({
    selector: 'cart-saved-product',
    templateUrl: './cart-saved-product.component.html',
    styleUrls: ['../cart-product-summary-saved-product-shared.scss'],
    standalone: false
})
export class CartSavedProductComponent extends BaseComponent implements OnInit{

    oldVal: number;
    savedProducts$: Observable<ISavedProduct[]>;

    ProductUtil = ProductUtil;

    constructor(loggerService: LoggerService,
                userService: UserService,
                private cartService: CartService,
                private alertUtilService: AlertUtilService,
                private savedProductService: CartSavedProductService
    ) {
        super(userService, loggerService);
    }

    ngOnInit() {
        this.savedProducts$ = this.savedProductService.savedProducts$.pipe(
            map((savedProducts: ISavedProduct[]) => savedProducts)
        );
    }

    deleteFromSaved(emittedValue: any) {
        const product = emittedValue.product;
        if (product) {
            this.savedProductService.deleteSavedForLaterProduct(product.usanaId, product.mhpId).subscribe(
                () => {}, // eslint-disable-line @typescript-eslint/no-empty-function
                (error: any) => {
                    this.log.error("Error delete product from save for later", error);
                }
            );
        }
    }

    productAddBackToCart(savedProduct: ISavedProduct) {
        if (savedProduct) {
            if (Util.isValidQuantity(savedProduct.quantity)) {
                this.cartService.adjustCartQuantity(savedProduct.product, 1, (savedProduct.mhpId == 0? undefined: savedProduct.mhpId), false).subscribe((success: boolean) => {
                    if (!success) {
                        this.adjustCartFailure();
                    } else {
                        this.removeFromSaved(savedProduct);
                    }
                }, (error: any) => {
                    this.log.error("Error adjusting quantity", error);
                    this.adjustCartFailure();
                });
            }
        }
    }

    removeFromSaved(savedProduct: ISavedProduct) {
        this.savedProductService.deleteSavedForLaterProduct(savedProduct.product.usanaId, savedProduct.mhpId).subscribe(
            () => {}, // eslint-disable-line @typescript-eslint/no-empty-function
            (error: any) => {
                this.log.error("Error adding saved product back to cart", error);
                this.adjustCartFailure();
            }
        );
    }

    adjustCartFailure() {
        this.alertUtilService.addFail({body: "cart.error.update.quantity", translate: true});
    }
}
